import _ from 'lodash';

export const buildDisplayName = (first_name: string, last_name: string, number?: string, email?: string) => {
    const jerseyNumber = number ? `#${number}` : '';

    let name = formatFirstNameLastName('normal', first_name, last_name);
    if (name === '') name = email || '';

    return _.compact([name, jerseyNumber]).join(', ');
};

function formatFirstNameLastName(variant: 'short' | 'normal', firstName?: string, lastName?: string) {
    let formattedName = '';
    if (!firstName) {
        formattedName = lastName || '';
    } else if (!lastName) {
        formattedName = firstName || '';
    } else {
        const formattedFirstName = variant === 'short' ? firstName[0] : firstName;
        formattedName = `${formattedFirstName} ${lastName}`;
    }

    return formattedName.trim();
}

export const buildShortDisplayName = (firstName: string, lastName: string, number?: string, email?: string) => {
    const formattedName = formatFirstNameLastName('short', firstName, lastName);
    if (formattedName !== '') {
        return formattedName;
    }

    if (number) {
        return `#${number}`;
    }

    return email || '';
};
